module.exports = __webpack_public_path__ + "img/tablet-outline-black.6f1766b5.svg";